// This component has been added ad-hoc by sales-leader-insights-fe team: https://private.hubteam.com/janus/groups/hs-sales-leader-insights-fe
// For any questions/concerns, please use Slack channel: #sales-leader-insights-fe

import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranscriptQuickFilterButtonContent = ({
  showShepherd,
  label
}) => /*#__PURE__*/_jsx(TruncateString, {
  tooltip: showShepherd,
  maxWidth: 120,
  children: label
});